import React, { FunctionComponent } from 'react';
import { Icon } from 'react-icons-kit';
import { externalLink } from 'react-icons-kit/fa/externalLink';
import { copy } from 'react-icons-kit/fa/copy';
import withStyles from 'react-jss';

import { ClassProp } from 'helpers/types';

const styles = {
  wrapper: {
    background: '#e0e8ed !important',
    padding: '4px 8px !important',
    borderRadius: '10px !important',
  },
  icon: {
    marginLeft: '10px !important',
    verticalAlign: 'text-bottom !important',
    cursor: 'pointer !important',
    color: '#000 !important',
    '&:hover': {
      opacity: 0.6,
    },
  },
};

type Props = {
  classes: ClassProp<typeof styles>;
  url: string;
};

const extractImageId = (url = '') => {
  const parts = url.split('/');
  const file = parts[parts.length - 1];
  // remove extension
  return file.split('.')[0];
};

const ImageId: FunctionComponent<Props> = ({ url, classes }) => {
  const imageId = extractImageId(url);

  return imageId ? (
    <span className={classes.wrapper}>
      {imageId}
      <a href={url} target="_blank" rel="noreferrer" className={classes.icon}>
        <Icon icon={externalLink} />
      </a>
      <Icon
        icon={copy}
        className={classes.icon}
        onClick={() => navigator.clipboard.writeText(imageId)}
      />
    </span>
  ) : null;
};

export default withStyles(styles)(ImageId);
